export const START_EVENT = 'START_EVENT';
export const SET_EVENT = 'SET_EVENT';
export const RESET_EVENT = 'RESET_EVENT';
